import { render, staticRenderFns } from "./IdentificationSelect.html?vue&type=template&id=46044d3a&scoped=true&"
import script from "./IdentificationSelect.vue?vue&type=script&lang=js&"
export * from "./IdentificationSelect.vue?vue&type=script&lang=js&"
import style0 from "./IdentificationSelect.scss?vue&type=style&index=0&id=46044d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46044d3a",
  null
  
)

export default component.exports